import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
export const AutoSizedText = ({ children , className , tooBigClassName , maxHeight  })=>{
    const [isTooBig, setIsTooBig] = useState(false);
    const [hasTriggeredResize, setHasTriggeredResize] = useState(false);
    const rootRef = useRef(null);
    useEffect(()=>{
        const node = rootRef.current;
        if (!node) {
            return;
        }
        const isTooBigNow = node.getBoundingClientRect().height > maxHeight;
        // hasTriggeredResize here to avoid infinite loops between adding the tooBig class and removing it
        // at certain viewport sizes
        if (isTooBigNow === isTooBig || hasTriggeredResize) {
            return;
        }
        setIsTooBig(isTooBigNow);
        setHasTriggeredResize(true);
    }, [
        rootRef,
        isTooBig,
        hasTriggeredResize,
        maxHeight
    ]);
    return /*#__PURE__*/ React.createElement("h1", {
        ref: rootRef,
        className: classnames(className, isTooBig && tooBigClassName)
    }, children);
};
export default AutoSizedText;
